var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "90%",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "2vh",
            title: _vm.editInfoPlus,
            "custom-class": "update-employee-plus-dialog sk-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formAllTabEmployee",
              staticClass: "update-employee-plus-form",
              attrs: {
                "label-width": "140px",
                model: _vm.formAllTabEmployee,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c("div", { staticClass: "update-employee-plus-content" }, [
                _c(
                  "div",
                  { staticClass: "employee-plus-panel" },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticClass: "update-employee-plus-tabs",
                        attrs: { type: "card" },
                        model: {
                          value: _vm.activeTabName,
                          callback: function ($$v) {
                            _vm.activeTabName = $$v
                          },
                          expression: "activeTabName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "Thông tin", name: "infoTab" } },
                          [
                            _c(
                              "div",
                              { staticClass: "common-info-tab" },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 24 } },
                                  [
                                    _c("el-col", { attrs: { span: 6 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "profile-sidebar-card" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-avatar-wrap",
                                            },
                                            [
                                              (_vm.formAllTabEmployee
                                                .updateEmployeeMainInfoRequest
                                                .avatarView &&
                                                _vm.showPicutreInitial) ||
                                              _vm.imageUrlPreview
                                                ? _c("el-image", {
                                                    staticClass:
                                                      "profile-avatar",
                                                    attrs: {
                                                      src: _vm.imageUrlPreview
                                                        ? _vm.imageUrlPreview
                                                        : _vm.formAllTabEmployee
                                                            .updateEmployeeMainInfoRequest
                                                            .avatarView,
                                                      fit: "cover",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c("el-upload", {
                                                ref: "upload",
                                                staticStyle: {
                                                  display: "none",
                                                },
                                                attrs: {
                                                  "show-file-list": false,
                                                  "on-change": _vm.toggleUpload,
                                                  "on-remove": _vm.handleRemove,
                                                  "auto-upload": false,
                                                  action: "",
                                                },
                                              }),
                                              !(
                                                (_vm.formAllTabEmployee
                                                  .updateEmployeeMainInfoRequest
                                                  .avatarView &&
                                                  _vm.showPicutreInitial) ||
                                                _vm.imageUrlPreview
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "avatar-trigger-area",
                                                      on: {
                                                        click:
                                                          _vm.triggerAvatarUpload,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-plus",
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          "Thêm ảnh đại diện"
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "avatar-actions-overlay",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "avatar-action-btn edit-btn",
                                                          attrs: {
                                                            type: "button",
                                                            title:
                                                              "Thay đổi ảnh",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.triggerAvatarUpload,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-edit-outline",
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "avatar-action-btn delete-btn",
                                                          attrs: {
                                                            type: "button",
                                                            title: "Xóa ảnh",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleRemove,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-delete",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "qr-bank-section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [_vm._v("Ảnh QR ngân hàng")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "qr-container-wrap",
                                                },
                                                [
                                                  (_vm.formAllTabEmployee
                                                    .updateEmployeeMainInfoRequest
                                                    .qrCodeWeb &&
                                                    _vm.showPicutreInitial) ||
                                                  _vm.qrUrlPreview
                                                    ? _c("el-image", {
                                                        staticClass:
                                                          "qr-bank-image",
                                                        attrs: {
                                                          src: _vm.qrUrlPreview
                                                            ? _vm.qrUrlPreview
                                                            : _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .qrCodeWeb,
                                                          fit: "contain",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c("el-upload", {
                                                    ref: "uploadQrBank",
                                                    staticStyle: {
                                                      display: "none",
                                                    },
                                                    attrs: {
                                                      "show-file-list": false,
                                                      "on-change":
                                                        _vm.toggleUploadQr,
                                                      "on-remove":
                                                        _vm.handleRemoveQr,
                                                      "auto-upload": false,
                                                      action: "",
                                                    },
                                                  }),
                                                  !(
                                                    (_vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .qrCodeWeb &&
                                                      _vm.showPicutreInitial) ||
                                                    _vm.qrUrlPreview
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "qr-trigger-area",
                                                          on: {
                                                            click:
                                                              _vm.triggerQrUpload,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-plus",
                                                          }),
                                                          _c("span", [
                                                            _vm._v("Thêm QR"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "qr-actions-overlay",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "avatar-action-btn edit-btn",
                                                              attrs: {
                                                                type: "button",
                                                                title:
                                                                  "Thay đổi QR",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.triggerQrUpload,
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-edit-outline",
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "avatar-action-btn delete-btn",
                                                              attrs: {
                                                                type: "button",
                                                                title: "Xóa QR",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.handleRemoveQr,
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-delete",
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-code-section",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "profile-code-label",
                                                },
                                                [_vm._v("Mã nhân sự")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "profile-code-value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest
                                                        .code
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-status-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [_vm._v("Trạng thái làm việc")]
                                              ),
                                              _c(
                                                "el-radio-group",
                                                {
                                                  staticClass:
                                                    "status-radio-group",
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest
                                                        .employeeStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .updateEmployeeMainInfoRequest,
                                                        "employeeStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "Đang làm",
                                                      },
                                                    },
                                                    [_vm._v("Đang làm")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "Tạm nghỉ",
                                                      },
                                                    },
                                                    [_vm._v("Tạm nghỉ")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "Nghỉ làm",
                                                      },
                                                    },
                                                    [_vm._v("Nghỉ làm")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "transition",
                                                {
                                                  attrs: {
                                                    name: "el-zoom-in-top",
                                                  },
                                                },
                                                [
                                                  _vm.formAllTabEmployee
                                                    .updateEmployeeMainInfoRequest
                                                    .employeeStatus ==
                                                    "Tạm nghỉ" ||
                                                  _vm.formAllTabEmployee
                                                    .updateEmployeeMainInfoRequest
                                                    .employeeStatus ==
                                                    "Nghỉ làm"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "status-date-wrap",
                                                        },
                                                        [
                                                          _vm.formAllTabEmployee
                                                            .updateEmployeeMainInfoRequest
                                                            .employeeStatus ==
                                                          "Tạm nghỉ"
                                                            ? _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    prop: "updateEmployeeMainInfoRequest.dateRetain",
                                                                    label:
                                                                      "Ngày tạm nghỉ",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-date-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        type: "date",
                                                                        format:
                                                                          "dd-MM-yyyy",
                                                                        "value-format":
                                                                          "yyyy-MM-dd",
                                                                        placeholder:
                                                                          "Chọn ngày",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .formAllTabEmployee
                                                                            .updateEmployeeMainInfoRequest
                                                                            .dateRetain,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .formAllTabEmployee
                                                                                .updateEmployeeMainInfoRequest,
                                                                              "dateRetain",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "formAllTabEmployee.updateEmployeeMainInfoRequest.dateRetain",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm.formAllTabEmployee
                                                            .updateEmployeeMainInfoRequest
                                                            .employeeStatus ==
                                                          "Nghỉ làm"
                                                            ? _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    prop: "updateEmployeeMainInfoRequest.dateLeave",
                                                                    label:
                                                                      "Ngày nghỉ làm",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-date-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        type: "date",
                                                                        format:
                                                                          "dd-MM-yyyy",
                                                                        "value-format":
                                                                          "yyyy-MM-dd",
                                                                        placeholder:
                                                                          "Chọn ngày",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .formAllTabEmployee
                                                                            .updateEmployeeMainInfoRequest
                                                                            .dateLeave,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .formAllTabEmployee
                                                                                .updateEmployeeMainInfoRequest,
                                                                              "dateLeave",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "formAllTabEmployee.updateEmployeeMainInfoRequest.dateLeave",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 9 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "info-section-card" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-inner-title" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-user",
                                              }),
                                              _vm._v(" Thông tin nhân sự"),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Họ tên",
                                                prop: "updateEmployeeMainInfoRequest.fullName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .fullName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "fullName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.fullName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Số điện thoại",
                                                        prop: "updateEmployeeMainInfoRequest.phone",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .phone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "phone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.phone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "updateEmployeeMainInfoRequest.gender",
                                                        label: "Giới tính",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio-group",
                                                        {
                                                          staticClass:
                                                            "gender-radio-group",
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .gender,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabEmployee
                                                                  .updateEmployeeMainInfoRequest,
                                                                "gender",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabEmployee.updateEmployeeMainInfoRequest.gender",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Nam",
                                                              },
                                                            },
                                                            [_vm._v("Nam")]
                                                          ),
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Nữ",
                                                              },
                                                            },
                                                            [_vm._v("Nữ")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày sinh",
                                                        prop: "updateEmployeeMainInfoRequest.birthday",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          clearable: false,
                                                          format: "dd-MM-yyyy",
                                                          "picker-options":
                                                            _vm.pickerOptions,
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày sinh",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .birthday,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "birthday",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.birthday",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Dân tộc",
                                                        prop: "updateEmployeeMainInfoRequest.ethnic",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .ethnic,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "ethnic",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.ethnic",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Email",
                                                prop: "updateEmployeeMainInfoRequest.email",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .email,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.email",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "updateEmployeeMainInfoRequest.cmnd",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                          },
                                                          slot: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Số định danh\n                          "
                                                          ),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  "Số định danh của nhân sự",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-info",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .cmnd,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "cmnd",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.cmnd",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày cấp",
                                                        prop: "updateEmployeeMainInfoRequest.cmndDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày cấp",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .cmndDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "cmndDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.cmndDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "section-divider",
                                              staticStyle: {
                                                margin: "16px 0 12px",
                                              },
                                            },
                                            [_vm._v("Tài khoản nhận lương")]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngân hàng",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .nameBank,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "nameBank",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.nameBank",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Số tài khoản",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .bankAccountNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "bankAccountNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.bankAccountNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 9 } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "info-section-card parent-card",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-inner-title" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-suitcase-1",
                                              }),
                                              _vm._v(
                                                " Thông tin công việc & Hôn nhân"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày vào",
                                                        prop: "updateEmployeeMainInfoRequest.startDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          placeholder:
                                                            "Chọn ngày vào",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .startDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "startDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.startDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          "Ngày ký hợp đồng",
                                                        prop: "updateEmployeeMainInfoRequest.contractDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          placeholder:
                                                            "Chọn ngày",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .contractDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "contractDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.contractDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày hết hạn",
                                                        prop: "updateEmployeeMainInfoRequest.endDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          placeholder:
                                                            "Ngày hết hạn",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .endDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "endDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.endDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Trình độ",
                                                        prop: "updateEmployeeMainInfoRequest.educationLevel",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .educationLevel,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "educationLevel",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.educationLevel",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Đối tượng",
                                                        prop: "updateEmployeeMainInfoRequest.idAccountTypeList",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            multiple: "",
                                                            placeholder:
                                                              "Chọn đối tượng",
                                                            clearable: "",
                                                            filterable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .idAccountTypeList,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabEmployee
                                                                  .updateEmployeeMainInfoRequest,
                                                                "idAccountTypeList",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabEmployee.updateEmployeeMainInfoRequest.idAccountTypeList",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.accountTypeList,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  value:
                                                                    item.id,
                                                                  label:
                                                                    item.name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Hôn nhân",
                                                        prop: "updateEmployeeMainInfoRequest.marriedStatus",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            filterable: "",
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .marriedStatus,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabEmployee
                                                                  .updateEmployeeMainInfoRequest,
                                                                "marriedStatus",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabEmployee.updateEmployeeMainInfoRequest.marriedStatus",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.options,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Số con",
                                                        prop: "updateEmployeeMainInfoRequest.numberChildren",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .numberChildren,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "numberChildren",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.numberChildren",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Địa chỉ thường trú",
                                                prop: "updateEmployeeMainInfoRequest.permanentAddress",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .permanentAddress,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "permanentAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.permanentAddress",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Chỗ ở hiện tại",
                                                prop: "updateEmployeeMainInfoRequest.address",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .address,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.address",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Ghi chú",
                                                prop: "updateEmployeeMainInfoRequest.note",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "textarea",
                                                  rows: 1,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .note,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.note",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "App Plus" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-1",
                                attrs: {
                                  border: "",
                                  data: _vm.plusIconAppUpdate.plusIconUpdate1,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    width: "50",
                                    type: "index",
                                    label: "STT",
                                    align: "center",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "iconName",
                                    "min-width": "130",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Hiển thị", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            model: {
                                              value: scope.row.statusShow,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "statusShow",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.statusShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Mở khóa", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.rootLockStatus
                                            ? _c("el-checkbox", {
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              })
                                            : _c("el-checkbox", {
                                                attrs: { disabled: "" },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-2",
                                attrs: {
                                  border: "",
                                  data: _vm.plusIconAppUpdate.plusIconUpdate2,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    width: "50",
                                    type: "index",
                                    label: "STT",
                                    align: "center",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "iconName",
                                    "min-width": "130",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Hiển thị", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            model: {
                                              value: scope.row.statusShow,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "statusShow",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.statusShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Mở khóa", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.rootLockStatus
                                            ? _c("el-checkbox", {
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              })
                                            : _c("el-checkbox", {
                                                attrs: { disabled: "" },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "Chức năng App Plus" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-1",
                                attrs: {
                                  border: "",
                                  data: _vm.listAppPlusConfig,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    width: "50",
                                    type: "index",
                                    label: "STT",
                                    align: "center",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "name",
                                    "min-width": "130",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Hoạt động",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleChangePlusConfig(
                                                  scope.row
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.showConfig,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "showConfig",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.showConfig",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.showButtonClick
                          ? _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "Cấu hình Cam",
                                  name: "commonConfig",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { offset: 7 } },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            ref: "multipleTable",
                                            staticStyle: {
                                              width: "700px",
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              "element-loading-spinner":
                                                "el-icon-loading",
                                              "element-loading-background":
                                                "rgba(255,255,255, 0)",
                                              data: _vm.plusCamList,
                                              "highlight-current-row": "",
                                              "header-cell-style":
                                                _vm.tableHeaderColor,
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                type: "index",
                                                label: "STT",
                                                width: "50",
                                                align: "center",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "cameraName",
                                                label: "Tên cam",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "description",
                                                label: "Trạng thái",
                                                width: "100px",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  scope.row
                                                                    .active,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "active",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row.active",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1960651438
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Tác vụ",
                                                width: "120",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                !scope.row
                                                                  .active,
                                                              size: "mini",
                                                              type: "success",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSettingCame(
                                                                  scope.row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Thiết lập\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3803529439
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm.showButtonClick
            ? _c(
                "div",
                { staticClass: "tab-infor-button update-employee-plus-footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialogByButton("formAllTabEmployee")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("formAllTabEmployee")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("CamSettingPlusDialog", {
        attrs: {
          showSettingCamera: _vm.showSettingCamera,
          idPlus: _vm.idPlus,
          idCamera: _vm.idCamera,
          cameraName: _vm.cameraName,
        },
        on: { close: _vm.handleCloseSettingCameraDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }